<template>
  <div class="d-flex flex-wrap">
    <div class="col-12 col-lg-4">
      <ClientProspectStatusList :data="data" :type="type" />
    </div>
    <div :id="`${type}-map`" class="col-12 col-lg-8 map relative">
      <gmap-map :center="geoloc" :zoom="6" style="width: 100%; height: 100vh">
        <gmap-marker
          v-for="(m, index) in markers"
          :icon="{
            url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
              getMarkerIcon(m.status),
            )}`,
            scaledSize: { width: 20, height: 20 },
          }"
          :key="index"
          :position="m.position"
          :clickable="true"
          @click="changeIndex(index)"
        >
          <gmap-info-window v-if="showByIndex === index">
            <h4>{{ m.firstName }} {{ m.lastName }}</h4>
            <a :href="clientHref(m.id)" target="_blank">
              {{ m.email }}
            </a>
            <p><strong>Statut:</strong> {{ getStatusLabel(m.status) }}</p>
          </gmap-info-window>
        </gmap-marker>
      </gmap-map>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ClientProspectStatusList from "@/components/client/ClientProspectStatusList";

export default {
  name: "ClientProspectMarkersMap",

  components: {
    ClientProspectStatusList,
  },

  props: {
    data: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      required: true,
    },
  },

  async mounted() {
    try {
      const google = await this.$gmapApiPromiseLazy();

      this.gmapIsLoaded =
        google?.maps && Object.keys(google.maps).includes("places");
    } catch (e) {
      this.gmapIsLoaded = false;
    }
  },

  data() {
    return {
      geoloc: {
        lat: 46.3969,
        lng: 2.6879,
      },
      gmapIsLoaded: false,
      showByIndex: null,
    };
  },

  computed: {
    ...mapGetters({
      clientStatus: "getClientStatus",
      prospectStatus: "getProspectStatus",
    }),

    availableStatuses() {
      return this.type === "clients" ? this.clientStatus : this.prospectStatus;
    },

    markers() {
      if (!this.data || !Array.isArray(this.data)) {
        return [];
      }

      return this.data
        .filter(
          (item) =>
            !!item.geoloc?.coordinates &&
            !!item.geoloc?.coordinates[0] &&
            !!item.geoloc?.coordinates[1],
        )
        .map((item) => ({
          position: {
            lat: item.geoloc.coordinates[1],
            lng: item.geoloc.coordinates[0],
          },
          ...item,
          status: this.type === "clients" ? item.status : item.prospect?.type,
        }));
    },
  },

  methods: {
    getMarkerIcon(status) {
      const color = this.getStatusColor(status);

      return `
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="${color}" viewBox="0 0 256 256">
          <path d="M128,16a88.1,88.1,0,0,0-88,88c0,75.3,80,132.17,83.41,134.55a8,8,0,0,0,9.18,0C136,236.17,216,179.3,216,104A88.1,88.1,0,0,0,128,16Zm0,56a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z"></path>
        </svg>
      `;
    },

    getStatusColor(status) {
      const statusObj = this.availableStatuses.find((s) => s.value === status);

      return statusObj ? statusObj.color : "#95a5a6";
    },

    getStatusLabel(status) {
      const statusObj = this.availableStatuses.find((s) => s.value === status);

      return statusObj ? statusObj.label : status;
    },

    clientHref(id) {
      const route = this.$router.resolve({
        name: "client-details",
        params: { id },
      });

      return route.href;
    },

    changeIndex(index) {
      this.showByIndex = this.showByIndex === index ? null : index;
    },
  },
};
</script>
